// @tennis-matches/services/winterdoppel/constants

export const WINTERDOPPEL_SERIES_KINDS = ["winter", "summer", "custom"];
export const WINTERDOPPEL_SERIES_KIND_DEFAULT = "winter";

/** free = Doppel-Partnerwünsche; training = flexible Spielgruppen */
export const WINTERDOPPEL_SERIES_MODES = ["free", "training"];
export const WINTERDOPPEL_SERIES_MODE_DEFAULT = "free";

/** Grobplanung/Warteliste: Quote vs. gleiche absolute Belastung */
export const WINTERDOPPEL_FAIRNESS_MODES = ["proportional", "equal_load"];
export const WINTERDOPPEL_FAIRNESS_MODE_DEFAULT = "proportional";

export function normalizeWinterDoppelFairnessMode(value) {
  const mode = String(value || "").trim();
  return WINTERDOPPEL_FAIRNESS_MODES.includes(mode)
    ? mode
    : WINTERDOPPEL_FAIRNESS_MODE_DEFAULT;
}

export const WINTERDOPPEL_INTEREST = ["yes", "maybe", "no"];
export const WINTERDOPPEL_WEEK_RULES = ["all", "even_kw", "odd_kw"];
export const WINTERDOPPEL_PLAN_STATUSES = ["draft", "final"];
export const WINTERDOPPEL_SESSION_STATUSES = [
  "proposed",
  "asked",
  "confirmed",
  "cancelled",
];
export const WINTERDOPPEL_ROLES = ["starter", "reserve"];
export const WINTERDOPPEL_RSVP = ["pending", "yes", "no", "maybe"];

/** ISO weekdays 1=Mon … 7=Sun */
export const WINTERDOPPEL_WEEKDAY_KEYS = [
  { value: 1, labelKey: "winterdoppel.weekday.mon" },
  { value: 2, labelKey: "winterdoppel.weekday.tue" },
  { value: 3, labelKey: "winterdoppel.weekday.wed" },
  { value: 4, labelKey: "winterdoppel.weekday.thu" },
  { value: 5, labelKey: "winterdoppel.weekday.fri" },
  { value: 6, labelKey: "winterdoppel.weekday.sat" },
  { value: 7, labelKey: "winterdoppel.weekday.sun" },
];
